// removed by extract-text-webpack-plugin
module.exports = {"legend_wrapper":"legend_wrapper__3HF5p","regularOtherItem":"regularOtherItem__ExVT0","total_contribution":"total_contribution__2y8ED","percentage":"percentage__3mspL","fundType":"fundType__jrtpy","legendCenter":"legendCenter__zkwaI","legendText":"legendText__341Ts","legendColor":"legendColor__3mTk-","legendLabel":"legendLabel__sr9kY"};


//////////////////
// WEBPACK FOOTER
// ./components/regular-other-legend/style.scss
// module id = mZqR
// module chunks = 0